import { jsx as _jsx } from "react/jsx-runtime";
function MovieTitleOption(props) {
    const title = typeof props.title !== 'undefined' ? props.title : props.value;
    return _jsx("option", { value: props.value, children: title });
}
const selectorStyle = {
    margin: '1em',
    width: 'calc(100% - 2em)',
    fontSize: '18px'
};
const MovieSelector = (props = {
    titles: [],
    loadingData: false
}) => {
    const titles = props.titles;
    let titlesList = [];
    const handleChange = (event) => {
        props.handleChange?.(event.currentTarget.value);
    };
    if (props.loadingData) {
        titlesList.unshift(_jsx(MovieTitleOption, { title: "(Loading...)", value: "" }, Math.random()));
    }
    else {
        titlesList = titles.map((title, index) => {
            const key = `__id_${index}`;
            return _jsx(MovieTitleOption, { value: title }, key);
        });
        titlesList.unshift(_jsx(MovieTitleOption, { title: "(select title to proceed)", value: "" }, "-1"));
    }
    return (_jsx("select", { value: props.value, onChange: handleChange, style: selectorStyle, disabled: props.loadingData, children: titlesList }));
};
export default MovieSelector;
